'use strict';
; (function () {
    angular.module("EMR.SelectUsersBasedOnSpecialityPopupModule", []);

    var SelectUsersBasedOnSpecialityPopupModuleRoutes = [
        {
            "state": false,
            "name": "emrSelectUsersBasedOnSpecialityPopup",
            "url": "emrSelectUsersBasedOnSpecialityPopup",
            "RoutingNumber": 4606,
            templateUrl: "AngularScripts/SelectUsersBasedOnSpeciality/Htmls/SelectUsersBasedOnSpecialityPopup.html",
            files: [
                "AngularScripts/SelectUsersBasedOnSpeciality/Services/SelectUsersBasedOnSpecialityService.js",
                "AngularScripts/SelectUsersBasedOnSpeciality/Controllers/SelectUsersBasedOnSpecialityPopupController.js",
                "AngularScripts/EhrAgGridHandler/Factories/EhrAgGridHandlerFactory.js",
            ]
        },

    ]

    angular.module('EMR.SelectUsersBasedOnSpecialityPopupModule')
        .constant("SelectUsersBasedOnSpecialityPopupModuleRoutes", SelectUsersBasedOnSpecialityPopupModuleRoutes)
        .config(["$stateProvider", "EmrRouteProvider", "SelectUsersBasedOnSpecialityPopupModuleRoutes",
            function ($stateProvider, EmrRouteProvider, SelectUsersBasedOnSpecialityPopupModuleRoutes) {
                EmrRouteProvider.registerStates(SelectUsersBasedOnSpecialityPopupModuleRoutes, $stateProvider);
            }]);
})();
